<template lang='pug'>
div(class='subheading') {{ greet }}
</template>

<script>
export default {
  props: ['text', 'client'],

  computed: {
    greet() {
      let { first_name, second_name, sex } = this.client
      return this.text
        .replace(/(<([^>]+)>)/gi, '')
        .replace('{first_name}', first_name)
        .replace('{second_name}', second_name)
        .replace('{sex ый|ая}', sex ? 'ый' : 'ая')
    }
  }
}
</script>
